import instance from '../config/axios';

export async function getOrderReportHistory(accessToken: string) {
  try {
    const response = await instance({
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      url: '/api/v1/order/report/history',
      method: 'GET',
    });

    return response.data;
  } catch (e) {
    console.log(e);
    return false;
  }
}
